import React from "react";

// Custom.
import Layout from "containers/Layout/Layout";
import { Form } from "@vocollege/components";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  GET_EDUCATION,
  UPDATE_EDUCATION,
  CREATE_EDUCATION,
} from "@vocollege/app/dist/modules/VoApi/graphql";

export default function EducationEdit() {
  // Methods.

  const getInitialState = () => {
    const initialState: { [key: string]: any } = {
      id: 0,
      code: "",
      status: 1,
      title: "",
      diplomaType: "",
      education:"",
    };
    return initialState;
  };

  return (
    <Layout>
      <Form
        onDataChange={(m, data) => {}}
        tabs={[
          {
            key: "content",
            label: I18n.get.misc.content,
            fields: [
              {
                name: "code",
                label: I18n.get.misc.code,
                type: "text",
                required: true,
                grid: {
                  xs: 12,
                  md: 9,
                },
              },
              {
                name: "status",
                label: I18n.get.status.published,
                type: "switch",
                required: true,
                grid: {
                  xs: 12,
                  md: 3,
                },
              },
              {
                name: "title",
                label: I18n.get.form.labels.title,
                type: "text",
                required: true,
                grid: {
                  xs: 12,
                },
                validation: {
                  required: true,
                },
              },
              {
                name: "diplomaType",
                label: I18n.get.diploma.labels.diplomaType,
                type: "checkboxes",
                required: false,
                /*
                 *  Diplomas, json checkboxes
                 *  "Diplomtyp"
                 *    * Ungdomsutbildning
                 *    * Vuxenutbildning
                 *    * YH-utbildning
                 *   "Utbildning"
                 *    * Vård och omsorgsprogrammet
                 *    * barn och fritidsprogrmmet med yrkesutgång mot funktionshinder
                * */
                grid: {
                  xs: 12,
                },
                params: {
                  availableValues: Object.entries(I18n.get.diploma.diplomaTypes).map(([key, value], i) => {
                    return {label:value, name:key, key:i};
                  }),
                }
              },
              {
                name: "education",
                label: I18n.get.diploma.labels.education,
                type: "checkboxes",
                required: false,
                grid: {
                  xs: 12,
                },
                params: {
                  availableValues: Object.entries(I18n.get.diploma.education.vuxen).map(([key, value], i) => {
                    return {label:value, name:key, key:i};
                  }),
                }
              },
            ],
          },
        ]}
        labels={{
          loading: I18n.get.form.labels.loadingContent,
          create: I18n.get.education.labels.createEducation,
          created: I18n.get.education.messages.educationSaved,
          updated: I18n.get.education.messages.educationSaved,
          deleted: I18n.get.education.messages.educationDeleted,
          fieldRequired: I18n.get.form.errors.required,
        }}
        operations={{
          category: "education",
          get: GET_EDUCATION,
          create: CREATE_EDUCATION,
          update: UPDATE_EDUCATION,
        }}
        paths={{
          back: "/content/educations",
        }}
        initialState={getInitialState()}
        pageTitleField="title"
        classes={{
          paper: "vo-global__content-with-toolbar",
          toolbar: "vo-global__content-toolbar",
        }}
      />
    </Layout>
  );
}
